<template>
  <div class="heat_analysis">
    <!-- 7. 区域热分析 -->
    <titleTem :passTitleData="passTitleData"></titleTem>

    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择地区 -->
        <!-- <el-col :md="24" :lg="12">
                  <div class="option region">
                    <div class="item_title">Please select the region:</div>
                    <el-select v-model="regionVal" placeholder="请选择" @change="changeArea">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      ></el-option>
                    </el-select>
                  </div>
        </el-col>-->
        <!-- 选择时间 -->
        <el-col :md="24" v-if="!isMyDate">
          <div class="option region">
            <div class="item_title">Select Time:</div>
            <el-date-picker
              @blur="getStartDate"
              type="date"
              placeholder="Start date"
              v-model="startDate"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsStart"
              size="large"
            ></el-date-picker>
            <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
            <el-date-picker
              @blur="getEndDate"
              type="date"
              placeholder="End date"
              v-model="endDate"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsEnd"
              size="large"
            ></el-date-picker>
          </div>
        </el-col>
        <el-col :md="24" v-else>
          <div class="option region">
            <div class="item_title">Select Time:</div>
            <DatePicker
              :startTime="startDate"
              :endTime="endDate"
              @startConfirm="startConfirm"
              @endConfirm="endConfirm"
              @startCancel="startCancel"
              @endCancel="endCancel"
              @startClear="startClear"
              @endClear="endClear"
            ></DatePicker>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="echarts_container">
      <!-- <EMap :newMapData="newMapData"></EMap> -->
      <EDayMap :data_info="data_info"></EDayMap>
    </div>
  </div>
</template>

<script>
import { listofCountries, regionalHeat } from "@/common/js/http/version3Api.js";
import titleTem from "./Title";
// import EMap from "../echarts/EMap";
import EDayMap from "../echarts/EDayMap";
import MapData from "@/conf/mapTestData.js";
import DatePicker from "../mobile/DatePickerLocal";

export default {
  name: "HeatAnalysis",
  components: {
    titleTem,
    // EMap,
    EDayMap,
    DatePicker
  },
  data() {
    return {
      isMyDate: false,
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.endDate === "" || this.endDate !== "") {
            let endDateVal = 1561910461 * 1000;
            if (endDateVal) {
              return (
                time.getTime() < 1561910461 * 1000 ||
                time.getTime() > new Date(this.endDate).getTime()
              );
            }
          } else {
            let endDateVal = this.endDate || 1561910461 * 1000;
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.startDate === "") {
            let beginDateVal = 1561910461 * 1000;
            if (beginDateVal) {
              return time.getTime() < 1561910461 * 1000;
            }
          } else {
            let beginDateVal = this.startDate;
            if (beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime();
            }
          }
        }
      },
      passTitleData: {
        titleName: "Region Volume Analysis",
        commentTxt:
          "It shows statistics of the brand posts by the foreign media in seven continents within a certain time frame (in past 2 years by default)."
      },

      newMapData: MapData,
      // 搜索条件
      regionVal: "",
      startDate: "",
      endDate: "",
      countryArray: [],
      clickTruetag: [],
      dynamicTags: [],
      options: [],
      clickState: false,
      data_info: []
    };
  },
  created() {
    //屏幕宽度
    if (document.documentElement.clientWidth < 768) this.isMyDate = true;
    else this.isMyDate = false;
    this.setDate();
  },
  mounted() {
    this.getlistofCountry();
    this.getAreaInfo();
  },
  methods: {
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(2, "years")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    getStartDate() {
      this.data_info = [];
      this.getAreaInfo();
    },
    getEndDate() {
      this.data_info = [];
      this.getAreaInfo();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.clickTruetag.splice(this.clickTruetag.indexOf(tag.value), 1);
      this.options.filter(item => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });
      this.regionVal = "";
      this.getAreaInfo();
    },
    getContent(val) {},
    //获取地图信息区域
    getAreaInfo() {
      if (this.startDate == null || this.startDate == 'Invalid date') {
        this.startDate = "";
      }
      if (this.endDate == null || this.endDate == 'Invalid date') {
        this.endDate = "";
      }
      let data = {
        companyId: this.$route.query.id,
        startTime: this.startDate,
        endTime: this.endDate,
        brandToken: localStorage.getItem("brand-token")
      };
      this.data_info = [];
      regionalHeat(data).then(res => {
        this.data_info = res.result.series[0].data;
      });
    },
    //获取国家列表
    getlistofCountry() {
      let data = {
        companyId: this.$route.query.id,
        brandToken: localStorage.getItem("brand-token")
      };

      listofCountries(data).then(res => {
        this.options = res.result;
        this.options.map(item => {
          item.disabled = false;
          return item;
        });
      });
    },
    changeArea(val) {
      this.clickState = true;
      this.options.filter(item => {
        if (item.value === this.regionVal) {
          item.disabled = true;
        }
      });
      if (this.clickState === true && this.regionVal !== "") {
        this.countryArray.push({ value: this.regionVal });
        for (var i = 0; i < this.countryArray.length; i++) {
          for (var j = i + 1; j < this.countryArray.length; j++) {
            if (this.countryArray[i].value == this.countryArray[j].value) {
              this.countryArray.splice(j, 1);
              j--;
            }
          }
        }
        this.dynamicTags = this.countryArray;
        this.clickTruetag.push(val);
      }
    },
    startConfirm(startTime) {
      this.startDate = this.$moment(new Date(startTime)).format("YYYY-MM-DD");
      this.getAreaInfo();
    },
    endConfirm(endTime) {
      this.endDate = this.$moment(new Date(endTime)).format("YYYY-MM-DD");
      this.getAreaInfo();
    },
    startCancel() {
      this.startDate = "";
      this.getAreaInfo();
    },
    endCancel() {
      this.endDate = "";
      this.getAreaInfo();
    },
    startClear() {
      this.startDate = "";
      this.getAreaInfo();
    },
    endClear() {
      this.endDate = "";
      this.getAreaInfo();
    }
  },
  watch: {
    startDate(newValue) {
      if (newValue == null) {
        this.getAreaInfo();
      }
    },
    endDate(newValue) {
      if (newValue == null) {
        this.getAreaInfo();
      }
    }
  }
};
</script>

<style scoped>
.time .date_item {
  line-height: 32px;
}
.condition_search .el-date-editor.el-input {
  width: 145px !important;
}
</style>